module.exports = __webpack_public_path__ + "static/media/07_tn.7bb5accc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/07_tn.jpg
// module id = 145
// module chunks = 0